import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetReviewsByDeviceResponse } from './get-reviews-by-device-response';
import { getReviewsByDeviceResponseSchema } from './get-reviews-by-device-response';

interface IGetReviewsByDeviceParams {
  period?: string;
}

export async function getReviewsByDeviceApi(
  params?: IGetReviewsByDeviceParams,
): Promise<IValidatedResponse<IGetReviewsByDeviceResponse>> {
  const query = params?.period ? `?period=${params.period}` : '';
  return getRequest<IGetReviewsByDeviceResponse>({
    path: `/progress/reviews/by-device${query}`,
    schema: getReviewsByDeviceResponseSchema,
  });
}
